module.exports = __webpack_public_path__ + "img/housing.a770dcc1.png";